/* eslint-disable react/prop-types */
import assign from 'lodash/assign';
import React from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';

import pathsManifest from '../../../../pathsManifest';
import RatingAndReviewActions from '../../../../flux/actions/RatingAndReviewActions';
import queryUtil from '../../../../utils/queryUtils';
import RateManager from './RateManager';

class ManagerPage extends React.Component {
  constructor(props) {
    super(props);
  }

  handleBack = () => {
    const { dispatch, routingLocation, propertyManagerRating } = this.props;

    const query = assign({}, queryUtil.parse(routingLocation.search), { propertyManagerRating });
    const queryString = queryUtil.stringify(query);
    dispatch(push(pathsManifest.propertyRatingAndReviewCommentPage + queryString));
  };

  handleNext = () => {
    // attach rating as a query param in case of a refresh
    const { dispatch, routingLocation, propertyManagerRating } = this.props;
    const query = assign({}, queryUtil.parse(routingLocation.search), { propertyManagerRating });
    const queryString = queryUtil.stringify(query);

    dispatch(push(pathsManifest.propertyRatingAndReviewManagerCommentPage + queryString));
  };

  handleRatePropertyManager = (rating) => {
    this.props.dispatch(RatingAndReviewActions.editManagerRating(rating));
  };

  render() {
    const { propertyManagerRating, propertyRating } = this.props;

    return (
      <div className="ManagerPage">
        <RateManager
          onEmojiRatingClick={this.handleRatePropertyManager}
          propertyManagerRating={propertyManagerRating}
          showBack={propertyRating}
          onBack={this.handleBack}
          onNext={this.handleNext}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  propertyManagerRating: state.ratingAndReview.propertyManagerRating,
  propertyRating: state.ratingAndReview.propertyRating,
  routingLocation: state.router.location,
});

export default connect(mapStateToProps)(ManagerPage);
